import { render } from "./InventoryImplementationTable.vue?vue&type=template&id=28b7bdd0&scoped=true"
import script from "./InventoryImplementationTable.vue?vue&type=script&lang=js"
export * from "./InventoryImplementationTable.vue?vue&type=script&lang=js"

import "./InventoryImplementationTable.vue?vue&type=style&index=0&id=28b7bdd0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b7bdd0"]])

export default __exports__